import React, {Component} from "react";
import {observer} from "mobx-react";
import {mesAutobind} from "@posco/posco-shared";
import MenuList from "./MenuList";
import MenuFavorList from "./MenuFavorList";
import {Code020Util, Common, FindInvCodeModal, Invcode010Util} from "@plm/o10-share-front";

import DevPageContainer from "../../devPage/container/DevPageContainer";
import O10g014111Container from "../../o10g014111/container/O10g014111Container";
import DetailSearchComponent from "../component/DetailSearchComponent";


// 실제 url은 짧게 출력하기 위한 정규식.
const customRegExp = /^\/common\/[^\/\s]+\/(inner\/)?/g;

@mesAutobind
@observer
class MenuComponent extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  state = {
    modalOpen: false,
    menuStatue: {
      A0010: false,
      A0015: false,
      A0020: false,
      A0025: false,
      A0030: false,
      A0035: false,
      A0040: false,
      A0045: false,
      A0050: false,
      A0055: false,
      A0060: false,
      A0065: false,
      A0070: false,
      A0075: false,
      A0080: false,
      A0085: false,
      A0090: false,
      A0095: false,
      C0010: false,
      C0015: false,
      C0020: false,
      C0025: false,
      C0030: false,
      C0035: false,
      C0040: false,
      C0045: false,
      C0050: false,
      C0055: false,
      C0060: false,
      C0065: false,
      C0070: false,
      C0075: false,
      C0080: false,
      C0085: false,
      bookmark: false,
      main: false
    },
    menuStatueReset: {
      A0010: false,
      A0015: false,
      A0020: false,
      A0025: false,
      A0030: false,
      A0035: false,
      A0040: false,
      A0045: false,
      A0050: false,
      A0055: false,
      A0060: false,
      A0065: false,
      A0070: false,
      A0075: false,
      A0080: false,
      A0085: false,
      A0090: false,
      A0095: false,
      C0010: false,
      C0015: false,
      C0020: false,
      C0025: false,
      C0030: false,
      C0035: false,
      C0040: false,
      C0045: false,
      C0050: false,
      C0055: false,
      C0060: false,
      C0065: false,
      C0070: false,
      C0075: false,
      C0080: false,
      C0085: false,
      bookmark: false,
      main: false
    },
    menuStatueResetOpen: {
      A0010: true,
      A0015: true,
      A0020: true,
      A0025: true,
      A0030: true,
      A0035: true,
      A0040: true,
      A0045: true,
      A0050: true,
      A0055: true,
      A0060: true,
      A0065: true,
      A0070: true,
      A0075: true,
      A0080: true,
      A0085: true,
      A0090: true,
      A0095: true,
      C0010: true,
      C0015: true,
      C0020: true,
      C0025: true,
      C0030: true,
      C0035: true,
      C0040: true,
      C0045: true,
      C0050: true,
      C0055: true,
      C0060: true,
      C0065: true,
      C0070: true,
      C0075: true,
      C0080: true,
      C0085: true,
      bookmark: false,
      main: false
    },
    toggleMenu: false, //true면 전체열기
    headerSrc: false,
    headerSetting: false,
    profile: false,
    // headerLink: false,
    profileNoti: 0,
    headerDetail: false
  };

  today = new Date();
  year = this.today.getFullYear();
  month = this.today.getMonth() + 1;
  date = this.today.getDate();

  getProfileNoti(value) {
    this.setState({profileNoti: value});
  }

  menuProfileToggle() {
    this.setState({profile: !this.state.profile});
  }

  headerSettingChange() {
    this.setState({headerSetting: !this.state.headerSetting});
  }

  menuStatueSet(list) {
    console.log("test", list);
    this.setState({menuStatue: list});
  }

  toggleMenu() {
    this.setState({toggleMenu: !this.state.toggleMenu}, () => {
      this.setState({menuStatue: this.state.toggleMenu ? this.state.menuStatueResetOpen : this.state.menuStatueReset});
    });
  }

  handleModal(val) {
    this.setState({modalOpen: val});
  }

  /* 통합검색 & 상세검색 */

  componentDidMount() {

    document.addEventListener("mousedown", this.handleClickOutside);

    Invcode010Util.findByDelegateCodeNameInvcode010("BIZ_TYPE_CODE").then((result) => {
      this.listNameSet(result, "bizTypeCodeOption");
    });
    Invcode010Util.findByDelegateCodeNameInvcode010("INVEST_CATEGORY_CODE").then((result) => {
      this.listNameSet(result, "invCategoryOptions");
    });
    Invcode010Util.findByDelegateCodeNameInvcode010("INVEST_PURPOSE_CODE").then((result) => {
      this.listNameSet(result, "investPurposeCodeOption");
    });
    Invcode010Util.findByDelegateCodeNameInvcode010("WORKS_CODE").then((result) => {
      this.selectListNameSet(result, "workCodeList");
    }); //사소구분

    Code020Util.findByRollCodeCode020("BP1").then((result) => {
      this.selectListNameSet2(result, "investProgLevelNameList");
    }); //진행구분
    Code020Util.findByRollCodeCode020("DP").then((result) => {
      this.selectListNameSet(result, "dpList");
    }); //역할검색
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside() { // (+)버튼 누름
    const selectListDetailModal = document.getElementsByClassName("visible menu transition"); //selectList
    const calenderDetailModal = document.getElementsByClassName("rc-calendar"); //calender

    if (this.state.headerDetail) { //상세검색창이열려있을 때! 실행

      /************************** IFRAME */
      let iframeiframe = "";
      const tagName = document.getElementsByTagName("iframe");
      if (tagName) {
        for (let i = 0; i < tagName.length; i++) {
          if (tagName[i].style && tagName[i].style.display === "block") { //현재 열려있는 iframe 찾기!
            iframeiframe = tagName[i].contentDocument.body;
            console.log("###iframeiframe", iframeiframe);
          }
        }
        iframeiframe.addEventListener("mousedown", (a) => {
          this.setState({headerDetail: false}, () => {
            this.closeSelectList();
          }); // 닫기
        });
      }
      /************************** MENU */
      document.addEventListener("mousedown", (a) => {
        if (this.state.headerDetail && (!this.modalRef.current.contains(a.target))) {

          console.log("calenderDetailModal", calenderDetailModal);
          if (selectListDetailModal.length === 0 && calenderDetailModal.length === 0) { //select List
            // this.setState({headerDetail: false}, () => {
            //   this.closeSelectList();
            // });
          }
        }
      });
    }
  }

  closeSelectList() {
    const openLov = document.getElementsByClassName("ui active visible multiple selection scrolling dropdown multipleChk scroll");
    if (openLov.length > 0) { //열려있으면
      openLov[0].remove();
    }
  }

  listNameSet(result, listNmae) {
    let list = [];
    result.forEach(function (data, idx) {
      list.push({
        text: data.text,
        key: data.value,
        value: data.value
      });
    });
    this.setState({[`${listNmae}`]: list});
  }

  selectListNameSet(result, listNmae) {
    let list = [];
    result.forEach(function (data, idx) {
      list.push({
        text: data.text,
        key: data.value,
        value: data.value
      });
    });
    this.setState({[`${listNmae}`]: list});
  }

  selectListNameSet2(result, listNmae) {//진행구분 (4/7)
    let list = [];
    result.forEach(function (data, idx) {
      list.push({
        text: data.text,
        key: data.text,
        value: data.text
      });
    });
    this.setState({[`${listNmae}`]: list});
  }

  /* *통합검색 */
  handleOnKeyPress = (e) => {
    if (e.key === "Enter") {
      this.headerSrcChange();
      this.setState({headerDetail: false});
    }
  };

  headerSrcChange() {
    this.props.searchStartApi(document.getElementById("headerSrcText").value);
  }

  /* *상세검색 */
  headerDetailChange() {
    this.setState({headerDetail: !this.state.headerDetail}, () => {
      if (!this.state.headerDetail) {
        document.getElementById("headerSrcText").value = ""; //통합검색 input창 글을 삭제하기
      }
    });
  }

  //TODO ----------- begin:: 개발용 추후 삭제 -----------------
  copyToClipboard(val) {
    const t = document.createElement("textarea");
    document.body.appendChild(t);
    t.value = val;
    t.select();
    document.execCommand("copy");
    document.body.removeChild(t);
  }

  copyUserInfo() {
    let copyText = "localStorage.clear(); sessionStorage.clear();";

    const tmpLocal = localStorage;
    for (const key in tmpLocal) {
      if (key !== "length" && key !== "clear" && key !== "getItem" && key !== "key" && key !== "removeItem" && key !== "setItem") {

        copyText += `localStorage.setItem('${key}', '${tmpLocal[key]}');`;
      }
    }

    const tmpSession = sessionStorage;
    for (const key in tmpSession) {
      if (key !== "length" && key !== "clear" && key !== "getItem" && key !== "key" && key !== "removeItem" && key !== "setItem") {
        copyText += `sessionStorage.setItem('${key}', '${tmpSession[key]}');`;
      }
    }
    this.copyToClipboard(copyText);
  }

  getinvestProgLevelNam(val) {
    switch (val) {
      case "Review":
        return "계획";
      case "Approve":
        return "진행";
      case "Complete":
        return "준공";
      case "Release":
        return "완료";
      case "Hold":
        return "유보";
      default:
        return "";
    }
  }

  render() {
    const {navState, menuList} = this.props;
    const {
      headerSrc, headerSetting,
      // 통합검색, 상세검색 관련 state
      headerDetail
    } = this.state;

    return (
      <div className={navState ? "open" : "close"}>
        <header>
          <div className="headerL">
            <h1 className="mgr-8"
                style={{cursor: "pointer"}}
                onClick={() => {
                  window.open("/o10t01-front/");
                }}
            >포스코 투자 관리 시스템</h1>
            {(Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").investmetRegistNm ||
              Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").projectNumber ||
              Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").pmNameNumber) ?
              <div className="headerC">
                <p>{Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").projectNumber && Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").projectNumber}</p>
                <span className="saveBar inHeader"/>
                <p>{Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").investmetRegistNm && Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").investmetRegistNm}</p>
                <span className="saveBar inHeader"/>
                <p>{Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").pmNameNumber && Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").pmNameNumber}</p>
                <span className="saveBar inHeader"/>
                <p>{this.getinvestProgLevelNam(Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").investProgLevelNam && Common.PotalUtil.getStorageItem("Posco.auth.invbpInfo").investProgLevelNam)}</p>
              </div>
              : null
            }
          </div>
          <div className="headerR">
            {Common.PotalUtil.getStorageItem("Posco.auth.userInfo").isPoscoUser === "Y" ?
              <>
                {/* 상세검색창 버튼 */}
                <span className={headerDetail ? "headerDetail minusIcon" : "headerDetail"}
                      onClick={this.headerDetailChange}/>
                {/* 검색창 */}
                <div className={"headerSrcWrap srcOpen"}>
                  <input type="text" id="headerSrcText" placeholder="검색어를 입력해주세요." onKeyPress={this.handleOnKeyPress}/>
                  <span onClick={this.headerSrcChange}/>
                </div>
                <span className="saveBar inHeader"/>
                <div className="headerLinkWrap">
                  <span>투자관련 링크 바로가기</span>
                  <div className={"settingConWrap"}>
                    <div className={"settingCon"}>
                      <ul>
                        <li>
                          <a onClick={() => {
                            if (this.props.projectNumber) {
                              //사업메뉴면 새창열기 설계자료실
                              window.open("/o10t01-front/o10g01-front/o10g015420");
                            } else {
                              //일반메뉴면 내부탭열기
                              Common.PotalUtil.addPotalTab("/o10t01-front/o10g01-front/o10g015420/");
                            }
                          }}>설계자료실</a>
                        </li>
                        {this.props.dwgSystemName !== null && this.props.dwgSystemName !== "" ?
                          <li>
                            {/*글로벌도면정보시스템*/}
                            <a
                              href={this.props.dwgSystemURL}
                              target="_blank">{this.props.dwgSystemName}</a>
                          </li>
                          : null
                        }
                        {this.props.kosisSystemName !== null && this.props.kosisSystemName !== "" ?
                          <li>
                            {/*환율/물가*/}
                            <a href={this.props.kosisSystemURL} target="_blank">{this.props.kosisSystemName}</a>
                          </li>
                          : null
                        }
                        {this.props.supSystemName !== null && this.props.supSystemName !== "" ?
                          <li>
                            {/*공급사 종합정보검색*/}
                            <a href={this.props.supSystemURL} target="_blank">{this.props.supSystemName}</a>
                          </li>
                          : null
                        }
                        {this.props.jibanSystemName !== null && this.props.jibanSystemName !== "" ?
                          <li>
                            {/*지반정보시스템*/}
                            <a href={this.props.jibanSystemURL} target="_blank">{this.props.jibanSystemName}</a>
                          </li>
                          : null
                        }
                        {this.props.safeSystemName !== null && this.props.safeSystemName !== "" ?
                          <li>
                            {/*안전보건 플랫폼 인허가검토*/}
                            <a href={this.props.safeSystemURL} target="_blank">{this.props.safeSystemName}</a>
                          </li>
                          : null
                        }
                      </ul>
                    </div>
                  </div>
                </div>
                <span className="saveBar inHeader"/>
              </> : null
            }
            <div className="headerSettingWrap">
              <span onClick={this.headerSettingChange}/>
              <div className={headerSetting ? "settingCon" : "settingCon disNone"}>
                <ul>
                  <li>
                    <p>화면설정</p>
                    <div>
                      <input type="radio" name="font" id="12px" value="12px"
                             defaultChecked={this.props.fontSizeState === "12px" ? true : false}/>
                      <label htmlFor="12px" onClick={() => {
                        this.props.changeFontSize("12px");
                      }}>12px</label>
                      <input type="radio" name="font" id="14px" value="14px"
                             defaultChecked={this.props.fontSizeState === "14px" ? true : false}/>
                      <label htmlFor="14px" onClick={() => {
                        this.props.changeFontSize("14px");
                      }}>14px</label>
                      <input type="radio" name="font" id="16px" value="16px"
                             defaultChecked={this.props.fontSizeState === "16px" ? true : false}/>
                      <label htmlFor="16px" onClick={() => {
                        this.props.changeFontSize("16px");
                      }}>16px</label>
                    </div>
                  </li>
                  {/*<li>*/}
                  {/*  <p>테마설정</p>*/}
                  {/*  <div>*/}
                  {/*    <input type="radio" name="theme" id="theme01" value="theme01" checked/>*/}
                  {/*    <label htmlFor="theme01">기본테마</label>*/}
                  {/*    <input type="radio" name="theme" id="dark" value="dark"/>*/}
                  {/*    <label htmlFor="dark">다크모드</label>*/}
                  {/*  </div>*/}
                  {/*</li>*/}
                  {(window.location.origin.includes("tinvest") || window.location.origin.includes("localhost")) && <li>
                    <p>언어설정</p>
                    <div>
                      <input type="radio" name="language" id="korean"
                             onClick={() => this.props.setLanguage("ko")}
                             defaultChecked={!sessionStorage.getItem("Posco.Multilang.Code") ? true : Common.PotalUtil.getStorageItem("Posco.Multilang.Code") === "ko"}
                      />
                      <label htmlFor="korean">한국어</label>
                      <input type="radio" name="language" id="english"
                             onClick={() => this.props.setLanguage("en")}
                             defaultChecked={!sessionStorage.getItem("Posco.Multilang.Code") ? false : Common.PotalUtil.getStorageItem("Posco.Multilang.Code") === "en"}
                      />
                      <label htmlFor="english">English</label>
                    </div>
                  </li>}
                  {/*----------- begin:: 개발용 쿼리스트링 ?dev=true일때만 나타남-----------------*/}
                  {window.location.origin.includes("tinvest") && new URLSearchParams(location.search).get("dev") === "true" &&
                    <li>
                      <DevPageContainer/>
                    </li>
                  }
                  {/*----------- end:: 개발용 추후 삭제 -----------------*/}
                </ul>
              </div>
            </div>
            <div className="logout" onClick={() => {
              if (Common.PotalUtil.getStorageItem("Posco.auth.userInfo").vendorId === "3050") {
                window.location.href = "/o10t01-front/logOutUser";
              } else {
                window.location.href = "/o10t01-front/";
              }
              Common.PotalUtil.clearStorage();
            }}/>
          </div>

          {/******** 상세검색창 ********/}
          <div id={"detailSearchComponentDiv"} ref={this.modalRef}
               style={{display: this.state.headerDetail ? "block" : "none"}}>
            <DetailSearchComponent
              headerDetail={this.state.headerDetail}
              headerDetailChange={this.headerDetailChange}
              detailSearchApi={this.props.detailSearchApi}
              invCategoryOptions={this.state.invCategoryOptions}
              bizTypeCodeOption={this.state.bizTypeCodeOption}
              investPurposeCodeOption={this.state.investPurposeCodeOption}
              dpList={this.state.dpList}
              workCodeList={this.state.workCodeList}
              investProgLevelNameList={this.state.investProgLevelNameList}
            />
          </div>


        </header>

        {/* 메뉴 전체 열림 버튼 */}
        <div
          className={this.props.navState === "open" || this.props.navState === "close" ? "navWholeOpen hide" : "navWholeOpen"}
          onClick={() => {
            this.props.changeNavState("open");
          }}/>
        {/*this.props.projectNumber가 없는 비사업메뉴의 경우 nonBusiness클래스 추가하여 색상 변경*/}
        <nav className={`${this.props.navState} ${!this.props.projectNumber && "nonBusiness"}`} onClick={() => {
          this.props.changeNavState("open");
        }}
          // ref={navRef}
        >

          {/* 메뉴 1단계 접히게 하는 버튼 */}
          <div className={this.props.navState === "close" ? "nav1stClose hide" : "nav1stClose"} onClick={(e) => {
            e.stopPropagation();
            this.props.changeNavState("close");
          }}/>

          {/* 메뉴 2단계 접히게 하는 버튼 */}
          <div className={this.props.navState === "open" ? "nav2ndClose hide" : "nav2ndClose"} onClick={(e) => {
            e.stopPropagation();
            this.props.changeNavState("last");
          }}/>

          <div style={{display: "none"}}>
            <iframe src="/o10g01-front/o10g015080"/>
          </div>


          {Common.PotalUtil.getStorageItem("Posco.auth.userInfo") && (
            <>
              <div className="logInfo">
                {/*// 새 알림이 있을 경우 button 내에 span을 추가해주세요*/}
                <button onClick={(e) => {
                  e.stopPropagation();
                  this.menuProfileToggle();
                }}>
                  {this.state.profileNoti &&
                    <span>N</span>
                  }
                </button>

                {/* 유저명 */}
                <span>{Common.PotalUtil.getStorageItem("Posco.auth.userInfo").employeeName}</span>
                {/* 오늘날짜 */}
                <span>{this.year + ". " + this.month + ". " + this.date}</span>
              </div>
              {/* 비사업메뉴 사용 시 나오는 슬라이드이며 프로젝트성 및 정비성 사업 메뉴를 사용할 경우 주석처리해주세요 */}
              {/* 새 알림이 있을 경우 newIcon을 추가해주세요 */}
              {!this.props.projectNumber &&
                <div className={!this.state.profile ? "profileWrap" : "profileWrap profileAct"} onClick={(e) => {
                  e.stopPropagation();
                }}>
                  {this.state.profile &&
                    <O10g014111Container
                      getProfileNoti={this.getProfileNoti}
                      open={this.state.profile}
                      openToggle={this.menuProfileToggle}
                    />
                  }
                </div>
              }
            </>
          )}
          {Common.PotalUtil.getStorageItem("Posco.auth.userInfo").isPoscoUser === "Y" &&
            <>
              <div className="search">
                <input type="text" placeholder="사업검색" style={{cursor: "pointer"}}
                       defaultValue={this.props.projectNumber || ""}
                       onClick={() => {
                         this.handleModal(true);
                       }}
                />
              </div>
              <FindInvCodeModal
                size={"fullscreen"}
                open={this.state.modalOpen}
                close={() => {
                  this.handleModal(false);
                }}
                choiceButton={false}
                onChange={() => {
                }}
                // onApply={this.applyFunc} //선택 클릭시 ▶▶▶▶▶
                gcsCompCode={Common.PotalUtil.getStorageItem("gcsCompCode")}
                multi={false} // true
              />
            </>
          }


          <div className="navWrap">
            {/*사업메뉴는 즐겨찾기 없음*/}
            {this.props.projectNumber ?
              null :
              <MenuFavorList
                favorMenuList={this.props.favorMenuList}
                adding={this.props.adding}
                menuStatue={this.state.menuStatue}
                menuStatueSet={this.menuStatueSet}
                activePattMenuIdArray={this.props.activePattMenuIdArray}
              />
            }
            {/*DB에 메인화면 추가하면서 삭제*/}
            {/*/!*사업메뉴는 메인화면 없음*!/*/}
            {/*{this.props.projectNumber ?*/}
            {/*  // 구 코드 - 사업메뉴면 메인화면 새창으로 띄우기*/}
            {/*  // <span onClick={() => {*/}
            {/*  //   window.open(`/o10t01-front/`);*/}
            {/*  // }}>*/}
            {/*  //    메인화면*/}
            {/*  // </span>*/}
            {/*  null*/}
            {/*  :*/}
            {/*  <div*/}
            {/*    // className={this.state.menuStatue.main ? "shown menuMain" : "hidden menuMain"}*/}
            {/*    className={"menuMain"}*/}
            {/*  >*/}
            {/*    <span onClick={() => {*/}
            {/*      this.menuStatueSet({...this.state.menuStatue, main: !this.state.menuStatue.main});*/}
            {/*    }}*/}
            {/*          className={this.props.activePattMenuIdArray.includes("00000") ? "thisPage" : null}*/}
            {/*    >*/}
            {/*      <Link*/}
            {/*        key={"00000"}*/}
            {/*        onClick={this.props.adding}*/}
            {/*        pattmenuid={"00000"}*/}
            {/*        pattmenuid1={"00000"}*/}
            {/*        to={"/o10g01-front/o10g014110/"}*/}
            {/*        pgmurl={"/o10g01-front/o10g014110/"}*/}
            {/*      >메인화면</Link>*/}
            {/*    </span>*/}
            {/*  </div>*/}
            {/*}*/}
            {menuList && menuList.length ? (
              <MenuList
                menuList={menuList}
                adding={this.props.adding}
                menuStatue={this.state.menuStatue}
                menuStatueSet={this.menuStatueSet}
                projectNumber={this.props.projectNumber}
                activePattMenuIdArray={this.props.activePattMenuIdArray}
                activePattMenuId1Array={this.props.activePattMenuId1Array}
                tabTabPattMenuIdArray={this.props.tabTabPattMenuIdArray}
              />
            ) : null}
          </div>
          <div
            className={`${this.props.navState === "close" || this.props.navState === "last" ? "tgAll hide" : "tgAll"}`}
            onClick={this.toggleMenu}
            name={this.state.toggleMenu ? "-" : "+"}>
            {this.state.toggleMenu ? "전체접기" : "전체열기"}
          </div>
          {/*/!* 로그아웃 *!/*/}
          {/*<div className="logout">*/}
          {/*  <span onClick={()=>localStorage.clear()}>로그아웃</span>*/}
          {/*</div>*/}
        </nav>
      </div>
    );
  }
}

export default MenuComponent;
